import { render, staticRenderFns } from "./WebsiteKnowledgebaseEdit.vue?vue&type=template&id=6ad996aa&"
import script from "./WebsiteKnowledgebaseEdit.vue?vue&type=script&lang=js&"
export * from "./WebsiteKnowledgebaseEdit.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteKnowledgebaseEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports